<h2 mat-dialog-title>
  Dupliquer la FEB
</h2>

<mat-dialog-content>
  <div class="duplicate-message">
    <mat-icon color="primary">content_copy</mat-icon>

    <div>
      <p>
        Voulez-vous dupliquer la FEB
        <strong>
          {{ data.febLabel || data.febNumber || 'sélectionnée' }}
        </strong>
        ?
      </p>

      <p class="information">
        La nouvelle FEB sera créée sans label ni dates.
        Vous devrez compléter ces informations avant de pouvoir
        l’envoyer au fournisseur.
      </p>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    type="button"
    (click)="cancel()">
    Annuler
  </button>

  <button
    mat-raised-button
    color="primary"
    type="button"
    (click)="confirm()">
    <mat-icon>content_copy</mat-icon>
    Dupliquer
  </button>
</mat-dialog-actions>